import { LOCAL_STORAGE_KEY } from './const';

export const getFromStorage = (enterpriseId, pageId) => {
    try {
        if (localStorage.getItem(LOCAL_STORAGE_KEY)) {
            return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY))?.[enterpriseId]?.[pageId];
        }
    } catch (err) {
        console.log(err);
    }
};

export const setToStorage = (enterpriseId, pageId, value) => {
    try {
        const savedFilters = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
        localStorage.setItem(
            LOCAL_STORAGE_KEY,
            JSON.stringify({
                ...savedFilters,
                [enterpriseId]: {
                    ...savedFilters[enterpriseId],
                    [pageId]: value
                }
            })
        );
    } catch (err) {
        console.error(err);
    }
};
